import './ChartLegend.css';
export var legendContainer = '_1h0nto80-2-0-1';